import React, { useState } from "react";
import classes from "./styles/style.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles/blogSlider.css";
import PlayIcon from "../../assets/images/icons/playIcon.svg";
import VideoPlayer from "../../assets/components/VideoPlayer";

const BlogSlider = ({ data, dark }) => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerPadding: "0px",
    appendDots: (dots) => (
      <div>
        <ul>{dots}</ul>
      </div>
    ),
  };

  const SliderImage = ({ src }) => {
    return (
      <>
        <img
          className={classes.sliderImage}
          src={src}
          alt="sliderImage"
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      </>
    );
  };

  const SliderVideo = ({ cover, src }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
      <>
        <img className={classes.sliderImage} src={cover} alt="sliderCover" />
        <div
          className={classes.videoBG}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(true);
          }}
        ></div>
        <div
          className={classes.videButtonContainer}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(true);
          }}
        >
          <img src={PlayIcon} alt="playIcon" className={classes.playIcon} />
        </div>
        <VideoPlayer
          open={isOpen}
          closeHandler={() => setIsOpen(false)}
          videoUrl={src}
        />
      </>
    );
  };

  return (
    <div className={`w-100 custom-blog-slider ${dark ? "dark" : ""}`}>
      <Slider {...settings}>
        {data.map((item, index) => {
          return (
            <div
              className={classes.blogCardContainer}
              key={index}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              {item.type === "Image" ? (
                <SliderImage src={item.src} />
              ) : (
                <SliderVideo cover={item.videoCover} src={item.src} />
              )}
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default BlogSlider;
